import {
  AgilityIcon,
  ConnectionsThatCountIcon,
  CuttingEdgeTechIcon,
  EthicsIcon,
  InnovationIcon,
  PassionForExcellenceIcon,
  SustainabilityIcon,
  UnparalleledExpertiseIcon,
} from '../assets/DynamicIcons';
import ConstructionImg from '../assets/photos/ConstructionCover.jpg';
import ArchitectureImg from '../assets/photos/architectureService.jpg';
import EngineeringImg from '../assets/photos/engineeringService.jpg';
import { allProjectImages } from './ImagesImporter-utility';

export const LINKEDIN_LINK =
  'https://www.linkedin.com/company/a-to-x-engineering-services-sarl';
export const INSTAGRAM_LINK = 'https://www.instagram.com/atox.lb';
export const FACEBOOK_LINK =
  'https://www.facebook.com/people/A-To-X-Engineering-Services/100078271245632/';
export const TIKTOK_LINK = 'https://www.tiktok.com/@atox.lb';
export const WHATSAPP_NU = ' https://wa.me/+96171222344';
export const PORTFOLIO_LINK =
  'https://onedrive.live.com/download?id=9C0A563D6EDBAEBA!sc72c6bd87fc64a979e0cdc4f614ea916&resid=9C0A563D6EDBAEBA!sc72c6bd87fc64a979e0cdc4f614ea916&cid=9c0a563d6edbaeba&ithint=file%2cpdf&redeem=aHR0cHM6Ly8xZHJ2Lm1zL2IvYy85YzBhNTYzZDZlZGJhZWJhL0lRVFlheXpIeG4tWFNwNE0zRTloVHFrV0FaZm9vdlIwaHdkQVVDNDM1YkJxUVJn&migratedtospo=true';

export const coreValues = [
  {
    icon: <InnovationIcon />,
    title: 'Innovation',
    description:
      'We drive creativity and forward-thinking in every project, staying at the forefront of engineering advancements to deliver solutions that meet modern challenges. We don’t just think outside the box, we reinvent it. Every project is a canvas for our inventive spirit, leading to pioneering results that push boundaries and set new standards',
  },
  {
    icon: <AgilityIcon />,
    title: 'Agility',
    description:
      'In the fast-paced world of engineering, agility is key. We move swiftly and seamlessly, adapting to changes and challenges with a proactive mindset. Our flexibility allows us to pivot when necessary, ensuring we deliver top-notch results with efficiency and speed',
  },
  {
    icon: <EthicsIcon />,
    title: 'Ethics',
    description:
      'We operate with the highest moral standards, ensuring transparency, respect, and accountability in every interaction. Our commitment to ethical conduct is reflected in our decisions and actions, ensuring we build enduring, trustworthy relationships',
  },
  {
    icon: <SustainabilityIcon />,
    title: 'Sustainability',
    description:
      'Our commitment to sustainability is unwavering. We integrate eco-friendly practices into every project, ensuring that our engineering solutions not only meet today’s needs but also preserve resources for future generations. We aim to leave a positive, lasting impact on the environment',
  },
];
export const whyChooseuS = [
  {
    icon: <UnparalleledExpertiseIcon />,
    title: 'Unparalleled Expertise',
    description:
      'Our team brings together a diverse range of skills and expertise, ensuring that we can handle any challenge that comes our way. With specialists in every field, we offer a one-stop solution for all your engineering needs',
  },
  {
    icon: <CuttingEdgeTechIcon />,
    title: 'Cutting-Edge Technology',
    description:
      'We leverage breakthrough tools and inventive techniques to ensure our projects are not just completed but are exemplary. By continuously adopting and integrating the most advanced methodologies, we achieve exceptional accuracy, streamline processes to save time, and produce superior quality in all our aspects',
  },
  {
    icon: <PassionForExcellenceIcon />,
    title: 'Passion for Excellence',
    description:
      'Our team is driven by a passion for delivering outstanding results. We don’t settle for mediocrity; we strive for excellence in every project, infusing our work with dedication and enthusiasm for what we do, transforming every challenge into an opportunity for greatness. We believe that the details matter, and it’s in these details that we find the potential for extraordinary results',
  },
  {
    icon: <ConnectionsThatCountIcon />,
    title: 'Connections that Count',
    description:
      'We believe in building relationships, not just completing projects. Our dedicated team is always ready to offer the assistance and insights you need throughout your journey with us. We are committed to supporting you with timely assistance and expert answers. We offer ongoing support to ensure your satisfaction after the job is done, giving you peace of mind',
  },
];

export const SERVICES = [
  {
    id: 1,
    img: ArchitectureImg,
    title: 'Architecture',
    description:
      'We blend visionary design with practicality, creating spaces that inspire and elevate everyday experiences. By combining aesthetic innovation with functional integrity, we ensure our buildings are as beautiful as they are purposeful',
    blurHash: 'LJHVYa?G?vtR*0t8x[WXo~NG8{kB',
  },
  {
    id: 2,
    img: EngineeringImg,
    title: 'Engineering',
    description:
      'We lead the way in engineering design, shaping everything from complex systems to iconic structures. Our team of experts utilizes the latest technologies and methodologies to deliver precise, innovative, optimized, and efficient designs in compliance with international standards, codes, and regulations',
    blurHash: 'LVJRp$^5_4E*ScRjMyX7.8XSM|r?',
  },
  {
    id: 3,
    img: ConstructionImg,
    title: 'Construction',
    description:
      'From concept to completion, our construction services ensure your projects are built to the highest standards. We manage every aspect of the construction process, guaranteeing quality, safety, and timely delivery',
    blurHash: 'LNEDhs~VnNkC.S%2xtf+Q,f+RkR*',
  },
];

export const Project_Types_Categpories = {
  Architecture: ['Interior Designs', 'Residential Exteriors'],
  Engineering: [
    'Facade',
    'Steel Structure',
    'Reinforced Concrete',
    'Speciality Design',
  ],
  Construction: ['External Works', 'Internal Works', 'Street Furniture'],
};
export const PROJECTS = [
  {
    id: 1,
    img: allProjectImages['SAFAR - KUWAIT'],
    title: 'SAFAR - KUWAIT',
    type: 'Architecture',
    subType: 'Residential Exteriors',
    description: 'This modern residential facade embodies a minimalist aesthetic with clean lines and geometric forms. A prominent rectangular frame adds depth and visual interest, while the use of textured stone and concrete in earthy tones introduces warmth and contrast. The tropical landscaping, with lush greenery, enhances the inviting ambiance, seamlessly blending natural elements with contemporary design.',
  },
  {
    id: 2,
    img: allProjectImages['RMEIL 1739 - BEIRUT'],
    title: 'RMEIL 1739 - BEIRUT',
    type: 'Architecture',
    subType: 'Interior Designs',
    description: 'This design of a residential apartment exudes a contemporary and edgy aesthetic. The bold use of red accents against a dark backdrop creates a dramatic and captivating ambiance. The inclusion of playful and artistic elements, such as the KAWS figurines, adds a touch of personality to the space.',
  },
  {
    id: 3,
    img: allProjectImages['AL OUTAIBI - KUWAIT'],
    title: 'AL OUTAIBI - KUWAIT',
    type: 'Architecture',
    subType: 'Interior Designs',
    description: 'This design of a private residence creates a peaceful, modern feel through a carefully balanced blend of minimalist design and natural elements. The light, neutral tones are highlighted by soft lighting, adding warmth to the flooring and muted furnishings. The space has a calming atmosphere that feels very inviting and serene.',
    blurHash: 'LBA0?$WB00xu%LWBIVt700j[~qWB',
  },
  {
    id: 4,
    img: allProjectImages['AL YOUSSEFI - KUWAIT'],
    title: 'AL YOUSSEFI - KUWAIT',
    type: 'Architecture',
    subType: 'Interior Designs',
    description: 'This Moroccan-inspired area design features a vibrant blend of rich textures, intricate patterns, and bold colors. The walls are beautifully decorated, forming intricate designs complemented by arched niches that enhance the area\'s authenticity.',
  },
  {
    id: 5,
    img: allProjectImages['MU TOWERS - RIYADH KSA'],
    title: 'MU TOWERS - RIYADH KSA',
    type: 'Architecture',
    subType: 'Interior Designs',
    description: 'The reception area design evokes a sense of modern elegance with a touch of traditional design elements. A symmetrical layout, neutral color palette, and materials create a welcoming and sophisticated atmosphere.',
  },
  {
    id: 6,
    img: allProjectImages['AL ARADI- KUWAIT'],
    title: 'AL ARADI- KUWAIT',
    type: 'Architecture',
    subType: 'Residential Exteriors',
    description: 'This design of a private residence blends modern design with timeless materials. Expansive glass panels bring natural light indoors, while vertical stone pillars at the entrance add privacy and grandeur. The clean lines and balanced use of materials create a refined, luxurious look that stands out as a true statement of beauty.',
  },
  {
    id: 7,
    img: allProjectImages['AL AWADI - KUWAIT'],
    title: 'AL AWADI - KUWAIT',
    type: 'Architecture',
    subType: 'Residential Exteriors',
    description: 'This design of a private residence displays a captivating modern facade, defined by striking geometry and a mix of materials that make a bold statement. Expansive glass openings contrast with solid textures, creating a dynamic play between light and form.',
  },
  {
    id: 8,
    img: allProjectImages['Verdun 1356'],
    title: 'VERDUN 1356',
    type: 'Construction',
    subType: 'External Works',
    description: 'Supplying and mechanical fixation of Terrazzo Artificial Stone Cladding, installation of ACP Cladding. Supplying and Installation of HVAC including air conditioning system, smoke system and ventilation system. Supplying and Installation of wood doors, fire-rated doors, and aluminum façade openings.',
  },
  {
    id: 9,
    img: allProjectImages['Hiya Chair'],
    title: 'HIYA CHAIR-BEIRUT',
    type: 'Construction',
    subType: 'Street Furniture',
    description: 'This chair is a love letter to Beirut, blending the beauty of Lebanese architecture with the heartfelt simplicity that defines its people. Executed and Sponsored by A TO X, located in Zaitunay Bay and Beirut Souks — Your Pictures Complete Its Story!',
  },
  {
    id: 10,
    img: allProjectImages['Phoenix Tower'],
    title: 'PHOENIX TOWER-SODECO',
    type: 'Construction',
    subType: 'Internal Works',
    description: 'Main Entrance: Installation of ACP, wood and copper cladding, fixation of glass canopy and louvers. Duplex: Installation of curved glass. Roof: Installation of PV Panels.',
  },
  {
    id: 11,
    img: allProjectImages['Avenue 781'],
    title: 'AVENUE 781-HAZMIEH',
    type: 'Engineering',
    subType: 'Facade',
    description: 'Avenue 781, a remarkable 24-story building, features a curtain wall that defines its sleek exterior. The Mx curtain wall system integrates advanced engineering and aesthetics, providing both structural support and an inviting façade.',
  },
  {
    id: 12,
    img: allProjectImages['Pyramid- Kuwait Desert'],
    title: 'PYRAMID-KUWAIT DESERT',
    type: 'Engineering',
    subType: 'Steel Structure',
    description: 'The Steel Pyramid is a striking, modern structure designed to host events in the heart of Kuwait\'s desert. Its bold geometric form and innovative use of steel make it a standout venue. With dimensions of 16 x 26 meters, this bold geometric form is engineered to stand entirely without intermediate columns, allowing the pyramid to support itself.',
  },
  {
    id: 13,
    img: allProjectImages['plus 21 cyprus'],
    title: 'PLUS21-CYPRUS',
    type: 'Engineering',
    subType: 'Speciality Design',
    description: 'In our approach to U-Value analysis, we carefully evaluate heat flow through components like glass, frames, and insulation. This ensures our designs meet energy efficiency standards. By leveraging advanced simulations, we optimize insulation to reduce energy usage. Incorporating U-Value analysis into our designs allows us to achieve exceptional performance, ensuring that our projects are efficient in both hot and cold climates.',
  },
  {
    id: 14,
    img: allProjectImages['A.K.7 G.Y.M'],
    title: 'A.K.7 G.Y.M-CONGO',
    type: 'Engineering',
    subType: 'Facade',
    description: 'The A.K.7 G.Y.M. project incorporates a structural aluminum façade specifically engineered for a gym. This façade system provides exceptional thermal insulation and moisture resistance, ensuring a comfortable atmosphere.',
  },
  {
    id: 15,
    img: allProjectImages['KYE'],
    title: 'KYE RESORT-TABARJA',
    type: 'Engineering',
    subType: 'Facade',
    description: 'Lebanon’s largest beachfront resort, the aluminum facades and glass balustrades provide structural stability and resilience in a high-exposure environment, engineered to withstand environmental pressures, ensuring lasting safety and performance.',
  },
  {
    id: 16,
    img: allProjectImages['The Address'],
    title: 'THE ADDRESS-JNAH',
    type: 'Engineering',
    subType: 'Facade',
    description: 'Design of Aluminum Substructure for ACP Cladding.Design of Stair’s and Elevator’s Technal Mx Curtain Wall.Design of 38m Long Glass Canopy Supported on Cellular Beams for Shops.Design of Louvers for Façade Sides.Design of 270m^2 skylight supported on steel structure',
  },
  {
    id: 17,
    img: allProjectImages['VISION 3970'],
    title: 'VISION 3970-BEIT MERY',
    type: 'Engineering',
    subType: 'Facade',
    description: 'The design features a 60 m² L-shaped curtain wall, 8 meters high, with a focus on structural integrity. The system is carefully engineered to support glass panels while resisting environmental forces.',
  },
  {
    id: 18,
    img: allProjectImages['IKON hamra'],
    title: 'IKON-HAMRA',
    type: 'Engineering',
    subType: 'Facade',
    description: 'This project features the design of the GX/FX façade for a 14-floor building, incorporating finite element analysis (FEA) to ensure optimal structural performance.',
  },
  {
    id: 19,
    img: allProjectImages['Siklawi Building - abidjan'],
    title: 'SIKLAWI-ABIDJAN',
    type: 'Engineering',
    subType: 'Reinforced Concrete',
    description: 'This project involves the design of an 11-floor Reinforced Concrete Building with finite element analysis (FEA) for precise structural performance, incorporating a raft foundation to minimize differential settlement.',
  },
  {
    id: 20,
    img: allProjectImages['Swiss Butter - batroun'],
    title: 'SWISS BUTTER-BATROUN',
    type: 'Engineering',
    subType: 'Steel Structure',
    description: 'A robust steel structure supports the skylight, designed to provide stability across a 45 m² area. The structure balances load-bearing efficiency with minimal steel sections, ensuring durability and unobstructed light flow.',
  },
  {
    id: 21,
    img: allProjectImages['Iconic Steel Stairs- Cyprus'],
    title: 'ICONIC STAIR-CYPRUS',
    type: 'Engineering',
    subType: 'Steel Structure',
    description: 'The Iconic Spiral Staircase is engineered with precision, using stainless steel to create a robust, self-supporting structure that minimizes the need for additional supports, efficiently distributing loads throughout the spiral.',
  },
  {
    id: 22,
    img: allProjectImages['Vanrise- PV Panels'],
    title: 'VANRISE-BAABDA',
    type: 'Engineering',
    subType: 'Steel Structure',
    description: 'The Vanrise Project features the installation of 110 photovoltaic (PV) panels, reinforcing its commitment to sustainability. By integrating renewable energy, it promotes efficiency and supports long-term environmental goals.',
  }
];


